import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import Textarea from '@vtex/styleguide/lib/Textarea'
import Button from '@vtex/styleguide/lib/Button'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import errorReport from '@/checkout-instore-legacy/utils/errorReport'
import check from '@/checkout-instore-legacy/assets/images/check.svg'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

class ErrorMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMessage: '',
      isSubmitted: false,
    }
  }

  handleChange = (e) => {
    this.setState({ errorMessage: e.target.value })
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
    this.props.onSubmitModal()
    this.setState({ isSubmitted: true })
    if (!this.state.errorMessage) {
      return
    }
    errorReport(this.state.errorMessage)
    setTimeout(this.props.onCloseModal, 1200)
  }

  render() {
    const { errorMessage, isSubmitted } = this.state
    const { mediaQuery, intl } = this.props
    const trimmedErrorMessage = errorMessage.trim()
    const characterCountdownTextLabel = intl.formatMessage({
      id: 'characterCountdownText',
    })
    const isDesktop = mediaQuery({
      phone: false,
      tablet: false,
      desktop: true,
    })

    return !isSubmitted ? (
      <div className="tc">
        <ModalTitle id="reportError" />
        <form onSubmit={this.handleFormSubmit}>
          <Textarea
            id="errorMsg"
            maxLength="300"
            characterCountdownText={characterCountdownTextLabel}
            value={errorMessage}
            onChange={this.handleChange}
          />
          <div className="flex justify-end mt5 mt7-l">
            <Button
              id="errorSubmit"
              type="submit"
              variation="primary"
              disabled={!trimmedErrorMessage}
              block={!isDesktop}
            >
              <FormattedMessage id="submitError" />
            </Button>
          </div>
        </form>
      </div>
    ) : (
      <div className="tc flex items-center justify-center f4 pt8">
        <div>
          <img src={check} width="100" />
          <p>
            <FormattedMessage id="errorReportedMsg" />
          </p>
        </div>
      </div>
    )
  }
}

ErrorMessage.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onSubmitModal: PropTypes.func.isRequired,
  mediaQuery: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(withMediaQuery(ErrorMessage))
